import React, { ReactElement } from 'react'
import MySelect from '../formGroup/MySelect'
import { missingNifReason } from './Options'
import TextInput from '../formGroup/TextInput'
import YesNoButtons from '../formGroup/YesNoButtons'
import { IStep5Props } from '../../interfaces/Step5'
import Step5NifHook from '../../hooks/Step5NifHook'
import { getItemSuffix } from '../../utils/getItemSuffix'

function Step5Nif(props: IStep5Props): ReactElement {
  const { form, folderData, item } = props
  const {
    nifIsAvailableFalse,
    nifIsAvailableTrue,
    motifAbsenceNifAutre,
  } = Step5NifHook(props)
  const nifIsAvailableSuffix = `nif_is_available${getItemSuffix(item)}`
  const nifSuffix = `nif${getItemSuffix(item)}`
  const motifAbsenceNifSuffix = `motif_absence_nif${getItemSuffix(item)}`
  const autreMotifAbsenceMotifSuffix = `autre_motif_absence_nif${getItemSuffix(
    item
  )}`

  const { register, errors, triggerValidation } = form
  const nif_is_available = folderData[nifIsAvailableSuffix]
  const nif = folderData[nifSuffix]
  const motif_absence_nif = folderData[motifAbsenceNifSuffix]
  const autre_motif_absence_nif = folderData[autreMotifAbsenceMotifSuffix]

  return (
    <div className="col12 mt1 mt0md">
      <div className="row">
        <div className="col12 colLg6 dFlex alignItemsSmCenter justifyContentBetween">
          <label
            className="inputLabel inputLabelRequired"
            htmlFor={nifIsAvailableSuffix}
          >
            Disposez-vous d’un Numéro d’Identification Fiscale (NIF) ?
          </label>
        </div>

        <div className="col12">
          <YesNoButtons
            id={nifIsAvailableSuffix}
            name={nifIsAvailableSuffix}
            value={nif_is_available || ''}
            register={register({ required: true })}
            labelClassName="mb15"
            error={errors[nifIsAvailableSuffix]}
          />
        </div>

        {nifIsAvailableTrue && (
          <div className="col12 colXl4 colLg6">
            <TextInput
              register={register({ required: true, maxLength: 25 })}
              error={errors[nifSuffix]}
              name={nifSuffix}
              id={nifSuffix}
              defaultValue={nif || ''}
              label="Indiquez votre Numéro d’Identification Fiscale (NIF)"
              className="mb15 mb4lg"
              required
              inputClassName="inputField inputFieldSecondary"
              maxLength={25}
              placeHolder="Votre texte ici..."
              triggerValidation={triggerValidation}
            />
          </div>
        )}
        {nifIsAvailableFalse && (
          <>
            <div className="col12 colXl4 colLg6 mb4">
              <MySelect
                options={missingNifReason}
                value={motif_absence_nif || ''}
                register={register({ required: true })}
                name={motifAbsenceNifSuffix}
                id={motifAbsenceNifSuffix}
                error={errors[motifAbsenceNifSuffix]}
                label="Motif en cas d’absence de NIF"
                required
              />
              <p className="fontSizeXs textPrimaryDark">
                En cas de changement de votre situation fiscale une nouvelle
                auto-certification doit être complétée et signée sous 30 jours.
              </p>
            </div>
            <div className="colMd4">
              {motifAbsenceNifAutre && (
                <TextInput
                  register={register({ required: true, maxLength: 40 })}
                  error={errors[autreMotifAbsenceMotifSuffix]}
                  name={autreMotifAbsenceMotifSuffix}
                  id={autreMotifAbsenceMotifSuffix}
                  defaultValue={autre_motif_absence_nif || ''}
                  label="Préciser"
                  required
                  inputClassName="inputField inputFieldSecondary"
                  maxLength={40}
                  placeHolder="Votre texte ici..."
                  triggerValidation={triggerValidation}
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default Step5Nif
